import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProductCategoryService, SubCategory } from 'src/app/core/product-category.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';

@Component({
  selector: 'app-product-subcategory-data',
  templateUrl: './product-subcategory-data.component.html',
  styleUrls: ['./product-subcategory-data.component.scss'],
})
export class ProductSubcategoryDataComponent {
  @Input() product_category_id: string | undefined | null;
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  is_list_running: boolean = true;
  sub_category_collection?: SubCategory[];
  total?: number;

  constructor(private product_category_service: ProductCategoryService, private error_service: ErrorService) {}

  ngOnInit(): void {
    this.sub_category_collection = [];
    this.total = undefined;
    this.readProductCategory();
  }

  onRefresh(): void {
    this.sub_category_collection = [];
    this.total = undefined;
    this.readProductCategory();
  }

  readProductCategory(): void {
    if (this.product_category_id) {
      this.is_list_running = true;
      this.product_category_service.readProductCategory(this.product_category_id).subscribe({
        next: response => {
          const category = response.data;
          this.sub_category_collection = category.sub_category_collection;
          this.total = this.sub_category_collection ? this.sub_category_collection.length : 0;
          this.is_list_running = false;
        },
        error: error => {
          const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
          this.error_service.processApiError(processed_error.code, processed_error.message);
          this.is_list_running = false;
        },
      });
    }
  }
}
